import React, { useEffect, Component } from "react";
import Swal from 'sweetalert2';
// import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import routes from '../../routes';

const toast = (props) => {
    const { handleConfirmation, idProps: { match: { params: { id } }, history }, poc, status, msg, handleToastStatus, path, confirmationMsg,outSideClickEnable=true,htmlString='' } = props;
    if (status == "Success" || status == "success" || status == "SUCCESS" ) {
        Swal.fire({icon:'success',title:msg,allowOutsideClick:outSideClickEnable}).then((res) => {
            if (res.value || res.isConfirmed) {
                if (poc) {
                    handleToastStatus(false);
                } else {
                    history.push('/' + routes.mainRoute + '/' + path);
                }
            }
        });
    } else if (status == "error" || status == "Failed" || status == "Fail" || status== "failed" || status == "FAILED" || status == "FAIL") {
        Swal.fire({icon:'error',title:msg,allowOutsideClick:outSideClickEnable}).then(res => {
            handleToastStatus(false);
        });
    } else if (status == "required") {
        Swal.fire({
            title: confirmationMsg ? confirmationMsg : msg ? msg :'',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#506EE4',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
            heightAuto: false
        }).then((result) => {
            handleToastStatus(false);
        })
    } 
    else if( status == 'customDivRequired'){
        Swal.fire({
            title: confirmationMsg ? confirmationMsg : msg ? msg :'',
            html: htmlString,
            icon: 'warning',
            allowOutsideClick:outSideClickEnable,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
          }).then((result) => {
            if (result.isConfirmed) {
                handleConfirmation()
            }
            else{
                handleToastStatus(false);
            }
          })
    }
    else {
        Swal.fire({
            title: confirmationMsg ? confirmationMsg : msg ? msg :'',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#506EE4',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            allowOutsideClick:outSideClickEnable,
            heightAuto: false
        }).then((result) => {
            if (result.value || result.isConfirmed) {
                handleConfirmation(id)
            } else {
                handleToastStatus(false);
            }
        })
    }

    return "";
}

const index = (props) => {
    return toast(props);
}

export default index;